import { UserData, CREATE_USER_DATA } from "./types";

export function createUserData(userData: UserData) {
  return {
    type: CREATE_USER_DATA,
    payload: userData,
  };
}